import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, Text } from 'components';

type TwoLineCell = {
  text?: string;
  color?: string;
};

export const AvatarCell = ({ text, color }: TwoLineCell) => {
  const theme = useTheme();
  return (
    <Cell>
      <Avatar
        size="sm"
        letters={text}
        color={color ? (color.startsWith('#') ? color : `#${color}`) : ''}
      />
      <Text variant="bodySm" weight="regular" color={color ?? theme.palette.text.secondary}>
        {text}
      </Text>
    </Cell>
  );
};

const Cell = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
